module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('section', {
    staticClass: "wmdcp"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("我们的产品")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "item clearfix"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/img-logo-ctb.png"),
      "alt": "五级钻石纠错本"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("五级钻石纠错本")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("根据知识认知规律，科学设计五级纠错，个性化呈现。由知心慧学“个性化学习宝”系统智能整理，学管团队打印制作成精美活页夹。")])])]), _vm._v(" "), _c('div', {
    staticClass: "item clearfix"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/img-logo-tfb-2.png"),
      "alt": "两步皇冠个性化学习宝"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("两步皇冠个性化学习宝")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("知心慧学“个性化学习宝”系统针对学生自己的错题情况，量身定制个性化训练方案，查缺补漏，举一反三，避免学生盲目训练，减轻负担，提高学习效率。打印制作成精美活页夹。")])])]), _vm._v(" "), _c('div', {
    staticClass: "item clearfix"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/img-logo-tfb-3.png"),
      "alt": "三步尽管个性化学习宝"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("三步金冠个性化学习宝")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n              知心慧学“个性化学习宝”系统针对学生自己的错题情况，量身定制个性化训练方案，查缺补漏，举一反三。避免学生盲目训练，减轻负担，提高学习效率。错题、变式训练题同时呈现，方便纠错学习，体验感更好。打印制作成精美活页夹。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    staticClass: "img-wmdcp",
    attrs: {
      "src": require("../assets/img/img-wmdcp.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "jctf"
  }, [_c('img', {
    staticClass: "img-jctf",
    attrs: {
      "src": require("../assets/img/img-jctf.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cca3e736","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Parent.vue
// module id = 528
// module chunks = 2